import { render, staticRenderFns } from "./PaidCheckboxConfirmationModal.vue?vue&type=template&id=087bfcb2&scoped=true"
import script from "./PaidCheckboxConfirmationModal.vue?vue&type=script&lang=js"
export * from "./PaidCheckboxConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./PaidCheckboxConfirmationModal.vue?vue&type=style&index=0&id=087bfcb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087bfcb2",
  null
  
)

export default component.exports